import { Neo } from "@singularsystems/neo-react";
import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../ReportCategory";
import WacofCriteria from "./WacofCriteria";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import { Layout } from "@singularsystems/neo-canvas-grid";

@NeoReport("WacofReport", { category: ReportCategory.InvestorReports })
export default class WacofReport extends Report<WacofCriteria> {

    constructor(
        private dataCache = AppService.get(DomainTypes.Services.DataCache),
        private investorApiClient = AppService.get(DomainTypes.ApiClients.Investor)
    ) {
        super(WacofCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
            <Neo.GridLayout md={2} lg={3}>
                <div>
                    <Neo.FormGroup bind={this.criteria.meta.entityId} select={{ itemSource: this.dataCache.entities }} />
                    <Neo.FormGroup bind={this.criteria.meta.investorReferralTypeId} select={{ itemSource: this.dataCache.investorReferralTypes }} />
                    <Neo.FormGroup bind={this.criteria.meta.portfolioTypeId} select={{ itemSource: this.dataCache.portfolioTypes }} />
                    <Neo.FormGroup label="Investors">
                        <Neo.AutoCompleteDropDown
                            itemSource={this.investorApiClient.getInvestorLookups}
                            bindItems={this.criteria.meta.investorNames}
                            bindIds={this.criteria.meta.investorIds} />
                    </Neo.FormGroup>
                    <Neo.FormGroup bind={this.criteria.meta.isFlexiDiv} label="Flexi Div?" />
                    <Neo.FormGroup bind={this.criteria.meta.isCommission} label="Commission?" />
                </div>
            </Neo.GridLayout>
        </div>;
    }

    public getDefaultGridLayout(criteria?: WacofCriteria | undefined, propertyKey?: string | undefined): Layout.IGridLayout | undefined {
        return {
            "root": {
                "headerLines": 2,
                "columns": [
                    {
                        "key": "investorInvestmentId",
                        "sortDirection": 0
                    },
                    {
                        "key": "primeRate",
                        "suppressTotal": true
                    },
                    {
                        "key": "investmentRate",
                        "suppressTotal": true
                    },
                    {
                        "key": "linkedRate",
                        "suppressTotal": true
                    },
                    {
                        "key": "rate",
                        "total": {
                            "type": "weightedAverage",
                            "relatedColumn": "capitalAmountForTotal"
                        }
                    },
                    {
                        "key": "divCycleCount",
                        "suppressTotal": true
                    },
                    {
                        "key": "naca",
                        "total": {
                            "type": "weightedAverage",
                            "relatedColumn": "capitalAmountForTotal"
                        }
                    },
                    {
                        "key": "nacs",
                        "total": {
                            "type": "weightedAverage",
                            "relatedColumn": "capitalAmountForTotal"
                        }
                    },
                    {
                        "key": "nacm",
                        "total": {
                            "type": "weightedAverage",
                            "relatedColumn": "capitalAmountForTotal"
                        }
                    },
                    {
                        "key": "nacaPrime",
                        "total": {
                            "type": "weightedAverage",
                            "relatedColumn": "capitalAmountForTotal"
                        }
                    },
                    {
                        "key": "nacsPrime",
                        "total": {
                            "type": "weightedAverage",
                            "relatedColumn": "capitalAmountForTotal"
                        }
                    },
                    {
                        "key": "nacmPrime",
                        "total": {
                            "type": "weightedAverage",
                            "relatedColumn": "capitalAmountForTotal"
                        }
                    }
                ]
            }
        } as Layout.IGridLayout;
    }
}